export type PrimaryColorConfig = {
  name?: string
  light?: string
  main: string
  dark?: string
}

// Primary color config object
const primaryColorConfig: PrimaryColorConfig[] = [
  {
    name: 'primary-1',
    light: '#A379FF',
    // main: '#05a54d',
    main: '#1777f0',
    dark: '#7E4EE6'
  }
]

export default primaryColorConfig
